import i18n from '@/i18n';
import { MissionStatus } from '@/modules/companyNeed/views/details/missions/types';

export enum MissionStatusIconColor {
	YELLOW = 'yellow',
	GREEN = 'green',
	BLUE = 'blue',
	RED = 'red',
	GREY = 'grey',
	DARK_GREY = 'dark-grey',
}

export interface MissionStatusInfo {
	label: string;
	icon: string;
	color: MissionStatusIconColor;
}

export const missionStatusInfoMap: Partial<
	Record<MissionStatus, MissionStatusInfo>
> = {
	[MissionStatus.TO_PROCESS]: {
		label: i18n.global.t('page.companyNeed.missions.status.toProcess'),
		icon: 'workflow-2',
		color: MissionStatusIconColor.YELLOW,
	},
	[MissionStatus.TO_VALIDATE]: {
		label: i18n.global.t('page.companyNeed.missions.status.toValidate'),
		icon: 'workflow-3',
		color: MissionStatusIconColor.GREEN,
	},
	[MissionStatus.VALIDATED]: {
		label: i18n.global.t('page.companyNeed.missions.status.validated'),
		icon: 'workflow-4',
		color: MissionStatusIconColor.BLUE,
	},
	[MissionStatus.CANCELED]: {
		label: i18n.global.t('page.companyNeed.missions.status.canceled'),
		icon: 'workflow-5',
		color: MissionStatusIconColor.RED,
	},
};

const missionStatusTokenColor: Record<MissionStatusIconColor, string> = {
	[MissionStatusIconColor.YELLOW]: 'var(--yellow-base, #FAB305)',
	[MissionStatusIconColor.GREEN]: 'var(--green-base, #00A355)',
	[MissionStatusIconColor.BLUE]: 'var(--blue-base, #2051F8)',
	[MissionStatusIconColor.RED]: 'var(--red-base, #E51940)',
	[MissionStatusIconColor.GREY]: 'var(--icon-soft-400, #9297AA)',
	[MissionStatusIconColor.DARK_GREY]: 'var(--icon-sub-500, #636778)',
};

export const getMissionStatusTokenColor = (status: MissionStatus): string => {
	const color = missionStatusInfoMap[status]?.color;
	return (
		(color && missionStatusTokenColor[color]) ||
		missionStatusTokenColor[MissionStatusIconColor.GREY]
	);
};
